export class Step4 {
	public intitule = 'stepper.form.simp_an.step4';

	public infosAnnulation = 'form.simp_an.getinfosannulation';

	constructor() {}
}
